import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVehicleMake = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.411l-3.693 2.354A1.499 1.499 0 0 1 14 10.499V9.411l-3.69 2.352A1.5 1.5 0 0 1 8 10.498zm.01 10a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zm4 0a1 1 0 1 1 0 2H16a1 1 0 1 1 0-2zM10 9.589l3.693-2.354A1.5 1.5 0 0 1 14.45 7h.101c.201.007.399.054.58.14l.09.045.087.05c.17.11.316.25.43.416l.053.085.048.088c.106.21.161.44.161.676v1.088l3.693-2.353A1.5 1.5 0 0 1 20.45 7h.101c.201.007.399.054.58.14l.09.045.087.05q.257.166.43.416l.053.085.048.088c.106.21.161.44.161.676V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3z"
	})
});
export default SvgVehicleMake;
